<template>
  <div>
    <v-card elevation="1" max-width="90%" class="profile-data">
      <v-card-text>
        <div
          class=" mb-4"
          v-if="edit == false"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn class="primary-btn edit-btn " @click="openEditMode()">
            {{ $t("Edit Details") }}
          </v-btn>
        </div>

        <div class="details">
          <v-form v-model="valid" ref="form">
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("Curriculum") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9">
                <p>{{ info.curriculum }}</p>
              </v-col>
            </v-row>

            <!--  -->
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("Grade") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ info.grade }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true">
                <v-select
                  solo
                  v-model="updateObject.grade_id"
                  :items="dataObject.grades"
                  item-text="name"
                  item-value="id"
                  :rules="[validationRules.required]"
                  chips
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="edit == true">
              <v-col :class="locale == 'en' ? 'text-right' : 'text-left'">
                <v-btn
                  class="primary-btn"
                  @click="update"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("Update") }}</v-btn
                >
                <v-btn class="gray-btn" @click="cancelEdit">
                  {{ $t("Cancel") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";

export default {
  name: "studentTeachingAndCurriculum.vue",
  mixins: [validationMixin],
  props: ["info", "info_edit"],
  data() {
    return {
      loading: false,
      valid: false,
      validationErrors: [],
      updateObject: {
        grade_id: this.info_edit.grade_id
      },
      edit: false,
      str: "",
      dataObject: {
        grades: []
      }
    };
  },
  methods: {
    onFocus() {
      this.validationErrors = [];
    },
    openEditMode() {
      this.edit = true;
      this.fillEditObject();
    },
    cancelEdit() {
      this.edit = false;
    },
    fillEditObject() {
      this.updateObject = {
        curriculum: this.info.curriculum,
        grade_id: this.info_edit.grade_id
      };
    },
    update() {
      if (this.valid == false) {
        this.validate();
      } else {
        this.loading = true;
        this.$http
          .post(this.getApiUrl + "/student/profileData", this.updateObject, {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(Response => {
            this.loading = false;
            // emit update to parent
            if (
              Object.keys(Response.data.status.validation_errors).length > 0
            ) {
              this.validationErrors = Response.data.status.validation_errors;
            } else {
              this.$emit(
                "updated",
                Response.data.status.error,
                Response.data.status.message
              );
              this.cancelEdit();
            }
          });
      }
    },
    getGradesUnderCurriculum(curriculumId) {
      this.$http
        .get(this.getApiUrl + "/getGradesUnderCurriculum/" + curriculumId)
        .then(response => {
          // console.log(response.data.data);
          this.dataObject.grades = response.data.data;
        });
    }
  },
  mounted() {
    this.getGradesUnderCurriculum(this.info_edit.curriculum_id);
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";
@import "../assets/styles/_responsive.scss";

.profile-data {
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding: 2rem;
  .primary-btn {
    background-color: $main-color !important;
  }
  .details-table {
    td {
      min-width: 200px;
      padding-bottom: 2rem;
    }
  }
}
</style>
